import React from 'react';
import styles from './prompt-card.module.css';
import {sendIntelligentPromptView} from '../../lib/xes/log'

class promptCard extends React.Component {
  constructor(props) {
    super(props);
  }
  showBtnKit(){
    if(this.props.isEarly){
      /* 打点3.0 初期点击锦囊 */
      sendIntelligentPromptView(
        'initial'
      )
    }else{
      /* 打点3.0 后期点击锦囊 */
      sendIntelligentPromptView(
        'later'
      )
    }
    this.props.onClickKit()
  }
  render () {
    return (
      <div className={styles.root} >
        {/* 关闭按钮 */}
        <a className={ styles.btnClose} onClick={ () => { this.props.onClosePrompt() } } href='javascript:void(0)'></a>
        {/* 主动触发 */}
        {/* <div className={(this.props.isActive ? styles.container : styles.hide) + ' ' + styles.tipActive }>
          // 表情图片
          <div className={this.props.isBlank ? styles.tigerSurprised:styles.tigerCry}></div>
          <div  className = {styles.tipActiveBtnText} >
            <h3 className = {styles.msg}>{this.props.titleText}</h3>
            <p className = {styles.tips}>{this.props.descText}</p>
            <div className={styles.btnActive}>
              <a onClick={() => { this.props.onShowProblemSolving() }} className={(this.props.showBtnProblemSolving ? '' : styles.hide) + ' ' + styles.btnJtsl} href='javascript:void(0)'></a>
              <a onClick={() => { this.props.onShowKnowlege() }} className={(this.props.showBtnKnowlege ? '' : styles.hide) + ' ' + styles.btnZsd} href='javascript:void(0)'></a>
              <a onClick={() => { this.props.onSubmit() }} className={(this.props.showBtnSubmit ? '' : styles.hide) + ' ' + styles.btnSubmit} href='javascript:void(0)'></a>
            </div>
          </div>
        </div> */}

        {/* 被动触发 */}
        <div className={(!this.props.isActive ? styles.container : styles.hide) +' '+ styles.tipNotActive} >
          {/* 文案&按钮 */}
          <div className={styles.textContainer}>
            <p className={styles.textDesc} dangerouslySetInnerHTML={{__html: this.props.titleText}}></p>
            <p className={styles.textDesc + ' ' + styles.textDesc2} dangerouslySetInnerHTML={{__html: this.props.descText}}></p>
          </div>
          {/* <div className={styles.btnNotActive}>
            <a onClick={() => { this.props.onShowProblemSolving() }} className={(this.props.showBtnProblemSolving ? '' : styles.hide) + ' ' + styles.btnJtsl2} href='javascript:void(0)'></a>
            <a onClick={() => { this.props.onShowKnowlege() }} className={(this.props.showBtnKnowlege ? '' : styles.hide) + ' ' + styles.btnZsd2} href='javascript:void(0)'></a>
          </div> */}
          <div onClick={() => { this.showBtnKit() }} className={(this.props.showBtnKit ? '' : styles.hide) + ' ' + styles.btnJn} href='javascript:void(0)'></div>
        </div>
      </div>
    )
  }
}
export default promptCard